import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Notification extends Component {
  static propTypes = {
    kind: PropTypes.oneOf(['error', 'success', 'warning']),
    title: PropTypes.string,
    description: PropTypes.string,
    displayClose: PropTypes.bool,
  };

  static defaultProps = {
    displayClose: false,
    kind: 'success',
    title: '',
    description: '',
  };

  state = {
    closed: false,
  };

  onClose = () => {
    this.setState({ closed: true });
  };

  renderIcon = () => {
    const { kind } = this.props;

    if (kind === 'success') {
      return <i className="material-icons icon-success">check_circle</i>;
    }

    if (kind === 'error') {
      return <i className="material-icons icon-error">error</i>;
    }

    if (kind === 'warning') {
      return <i className="material-icons icon-warning">warning</i>;
    }

    return null;
  };

  render() {
    const { closed } = this.state;
    const { kind, title, description, displayClose, style } = this.props;

    if (closed) return null;

    return (
      <div style={style} className={`bx--inline-notification bx--inline-notification--${kind}`}>
        <div className="bx--inline-notification__details">
          {this.renderIcon()}
          <div className="bx--inline-notification__text-wrapper">
            <p className="bx--inline-notification__title">{title}</p>
            <br />
            <p className="bx--inline-notification__subtitle">{description}</p>
          </div>
        </div>
        {displayClose && (
          <button
            type="submit"
            className="bx--inline-notification__close-button"
            onClick={this.onClose}
          >
            <i className="material-icons">close</i>
          </button>
        )}
      </div>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification.js